import React from 'react';

import {bulkArchiveRequestTaskSchemas, bulkUnarchiveRequestTaskSchemas} from 'archive/ArchiveActions';
import useAreOrganizationSchemasCreatableQuery from 'auth/useAreOrganizationSchemasCreatableQuery';
import * as benchlingUtil from 'BenchlingUtil';
import {QueryResultType} from 'graphql-client/BenchlingQuery';
import {getStore} from 'redux-stores/Store';
import useAllRequestTaskSchemasQuery from 'requests/graphql/useAllRequestTaskSchemasQuery';
import * as RequestTaskSchemaDAO from 'requests/schemas/RequestTaskSchemaDAO';
import SchemasListing from 'schemas/SchemasListing';
import {SCHEMA_TYPES} from 'schemas/spec/SchemaConfigConstants';

import {RequestTaskSchemaGraphQL} from '../../../graphql-fragments/requests/schemas/__generated/RequestTaskSchemaGraphQL';

interface RequestTaskSchemasPageProps {
  taskSchemas: Array<RequestTaskSchemaGraphQL> | null;
  areOrganizationSchemasCreatable: boolean;
}

export class RequestTaskSchemasPage extends React.Component<RequestTaskSchemasPageProps> {
  _handleNavigateToCreate = (): void => {
    benchlingUtil.navigate(null, RequestTaskSchemaDAO.taskSchemaCreateURL());
  };

  override render(): JSX.Element {
    return (
      <SchemasListing
        schemas={this.props.taskSchemas}
        schemaType={SCHEMA_TYPES.REQUEST_TASK}
        navigateToCreate={this._handleNavigateToCreate}
        urlForSchema={RequestTaskSchemaDAO.taskSchemaURL}
        archiveSchemas={(ids: Array<string>, purpose: string) => {
          getStore().dispatch(bulkArchiveRequestTaskSchemas(ids, purpose));
        }}
        unarchiveSchemas={(ids: Array<string>) => {
          getStore().dispatch(bulkUnarchiveRequestTaskSchemas(ids));
        }}
        isWritable={this.props.areOrganizationSchemasCreatable}
      />
    );
  }
}

export default function QueryingRequestTaskSchemasPage(props: {}): JSX.Element {
  benchlingUtil.setWindowTitle('Task Schemas');

  const requestTaskSchemas = useAllRequestTaskSchemasQuery('cache-and-network');
  const areOrganizationSchemasCreatableResults = useAreOrganizationSchemasCreatableQuery();

  const areOrganizationSchemasCreatable =
    areOrganizationSchemasCreatableResults.queryResultType === QueryResultType.SUCCESS &&
    areOrganizationSchemasCreatableResults.areOrganizationSchemasCreatable;

  return (
    <RequestTaskSchemasPage
      taskSchemas={requestTaskSchemas}
      areOrganizationSchemasCreatable={areOrganizationSchemasCreatable}
    />
  );
}
